























































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import ZenButton from '@reciprocity/button';

import { MultiChoiceBlock } from 'zenComponents';
import { downloadImportTemplate, generateDownloadTemplateData } from '@/pages/import/download';

import AswStep3MapperWrapper from '../components/AswStep3MapperWrapper.vue';
import RequestList from '../components/RequestList.vue';
import { Audit } from '../types';

export default Vue.extend({
  name: 'ASWStep3',
  components: {
    AswStep3MapperWrapper,
    MultiChoiceBlock,
    ZenButton,
    RequestList,
  },
  props: {
    audit: {
      type: Object as () => Audit,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['routes', 'csrfToken', 'currentUser']),
    ...mapGetters('auditSetupWizard', {
      showMapper: 'isRequestMapperVisible',
      isManagedInZenGRC: 'isManagedInZenGRC',
      isManagedInExternalSystem: 'isManagedInExternalSystem',
      showNoControlsInScope: 'showNoControlsInScope',
      displayMapper: 'displayRequestMapper',
    }),
    ...mapGetters({
      featureFlagState: 'featureFlagState',
    }),
    displayRequestList(): boolean {
      return this.showMapper && !this.isManagedInZenGRC && !this.isManagedInExternalSystem;
    },
  },
  methods: {
    ...mapActions({
      showModal: 'modals/show',
    }),
    ...mapActions('auditSetupWizard', {
      setMapper: 'setRequestMapper',
      goToPreviousStep: 'goToPreviousStep',
    }),
    async choiceHandler(type: string) {
      const objectType: string = 'Request';
      let modal;
      if (type === 'import') {
        let message = null;
        if (this.audit.externalBoardMessage) {
          message = this.audit.externalBoardMessage;
        }
        modal = {
          type: 'AswStep3ImportCard',
          data: {
            managedIn: this.audit.managedIn.value,
            auditCode: this.audit.code,
            userEmail: this.currentUser.email.value,
            extendedMessage: message,
          },
        };
      } else {
        modal = {
          type: 'NewObject',
          data: {
            url:
              this.routes.sorNewObject.replace('__OBJECT_TYPE__', objectType) +
              `?prefill={"Audit":"${this.audit.code}"}`,
            type: objectType,
          },
        };
      }

      try {
        await this.showModal(modal);
        this.setMapper(true);
      } catch (e) {
        // User canceled modal
      }
    },
    downloadTemplate() {
      const filename = 'import_requests_template.csv';
      const data = generateDownloadTemplateData(
        this.audit.managedIn.value,
        this.audit.code,
        this.featureFlagState('new_ticketing')
      );

      downloadImportTemplate(filename, data, this.csrfToken);
    },
  },
});
